import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PSlideToggleComponent } from './p-slide-toggle.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    declarations: [PSlideToggleComponent],
    imports: [CommonModule, MatSlideToggleModule],
    exports: [PSlideToggleComponent]
})
export class PSlideToggleModule {}
